<template lang="pug">
  .brand.inline
    .header-logo 云抄表平台
</template>

<script>
export default {
  name: 'Logo'
}
</script>

<style lang="sass" scoped>
.header-logo
  font-size: 20px
  line-height: 36px
  span
    font-size: 16px
</style>



// WEBPACK FOOTER //
// Logo.vue?1c6a7d32